var ConstituentSearch = function(options){
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

ConstituentSearch.prototype = {

    constructor : ConstituentSearch,

    defaults : {
        eventId : '',
        autoSearch : false
    },

    _request : '',

    init : function(){
        var _this = this;

        var searchTimeout;
        $('.event-body').on('keyup', '.bind-search-field', function(e) {
            var $field = $(this);
            clearTimeout(searchTimeout);

            if ( e.keyCode == 13 || $(this).val().length > 1 ) {
                searchTimeout = setTimeout(function(){
                    _this.triggerSearch($field);
                }, 600);
            } else {
                _this.removeSearchResult($(this));
            }
        });

        if ( _this.settings.autoSearch ) {
            $('.event-body').on('focus', '.bind-search-field', function(e) {
                _this.triggerSearch($(this));

                UI.bindClickOut('.search-results-container', function(target){
                    $(target).addClass('hide-content');
                });
            });
        }

        $('.event-body').on('keydown', '.bind-search-field', function(e){
            if ( e.keyCode == 13 ) e.preventDefault();
        })

        $('.event-body').on('click', '.search-field-container .search-result-item', function() {
            var $checkbox_input = $(this).find('input'),
                selectedId = $checkbox_input.val(),
                $resultTag = $(this).closest('.search-field-container').find('.selected-result-tag');

            if ( $(this).hasClass('js-disabled') ) return false;

            // make sure the checkbox is selected
            $checkbox_input.prop('checked', true);

            // store the result selected
            $(this).parent().parent().data('entity', selectedId);

            // hide all the other results, and add hover search class
            $(this).addClass('active-search-result');
            $(this).parent().addClass('hide-content');
            $(this).closest('.search-results-container').addClass('hide-content');
            $(this).closest('.search-field-container').addClass('has-value has-selected-result');

            // add search result "tag"
            var _label = ( $(this).find('.js-search-result-tag-label').length > 0 ) ? $(this).find('.js-search-result-tag-label').text() : $(this).find('.search-result-item-label').text();

            $resultTag.find('.selected-result-tag-label').text(_label);
            $resultTag.attr('data-result-id', $checkbox_input.attr('id'));

            // disable search
            $(this).closest('.search-field-container').find('.search-field').prop('disabled', true);
        });

        $('.event-body').on('click', '.search-results-container .avatar', function(e){
            e.preventDefault();
        });

        $('.event-body').on('click', '.selected-result-tag .cancel-selection',function(){
            var $searchContainer = $(this).closest('.search-field-container');
            _this.removeSelected($searchContainer, true);
        });
    },

    filterTeamByClassification: function( searchTerm ) {
        $searchField = $( '.bind-search-field[data-search-team-term=\'' + searchTerm + '\']' );
        // Check if we need to filter by classification
        if ( $searchField.is( '[data-classification]' )) {
            return '&classification=' + $searchField.attr( 'data-classification' );
        } else {
            return '';
        }
    },

    triggerSearch: function($element) {
        var _this = this;

        var searchType = $element.attr('data-search-type'),
            resultsContainer = $element.attr('data-search-results');

        $('.hover-search-result').removeClass('hover-search-result');
        $element.parent().removeClass('no-search-results');

        if (_this._request != '') _this._request.abort();

        $(resultsContainer).removeClass('hide-content').addClass('is-searching');
        _this.translateType(searchType, $element);
    },

    translateType: function(type, $element) {
        var _this = this;

        var resultsContainer = $element.attr('data-search-results');

        switch (type) {
            case 'accounts':
                return _this.accounts(resultsContainer, $element.attr('data-search-account-term'));
            case 'teams':
                return _this.teams(resultsContainer,$element.attr('data-search-team-term'));
            case 'registration_teams':
                return _this.registrationTeams(resultsContainer,$element.attr('data-search-team-term'));
            case 'participants':
                return _this.participants(resultsContainer,$element.attr('data-search-account-term'));
            case 'event':
                return _this.event(resultsContainer);
        }
        return function() {};
    },
    teams: function(_parent, searchTerm) {
        var _this = this;

        $('.results-teams').remove();

        var data = 'source='+_this.settings.source+'&search_category=team&template=search_results&text=' + encodeURIComponent($(searchTerm).val());

        if ( _this.settings.source == 'vt' && $('#option-vt-registration').length && $('#option-vt-registration').is(':checked') ){
            data += '&joinTeamSearch=1';
        }

        data += _this.filterTeamByClassification( searchTerm );

        _this.executeSearch({
            postString: data,
            event: _this.settings.eventId,
            url: '/event/' + _this.settings.eventId + '/search/',
            listClass: 'results-teams content',
            header: ['Team title', 'Team owner'],
            entryName: 'team[id]',
            collectionAccessor: 'teams',
            formatEntry: function(entity, row, name, callback) {
                var contact = entity.originatingAccount.contact;
                var entryLi = '<li class="search-result-item"><label for="team-'+entity.id+'" class="search-result-item-label"><input name="'+name+'" type="radio" value="'+entity.id+'" id="team-'+entity.id+'" class="checkbox-field" />' + entity.title + ' ' + contact.firstName+' '+contact.lastName+'</label></li>';
                callback(entryLi);
            }
        }, function(){
            return false;
        },
        _parent);
    },
    registrationTeams: function(_parent, searchTerm) {
        var _this = this,
        $searchField = $( '.bind-search-field[data-search-team-term=\'' + searchTerm + '\']' ),
        data = '';

        data += 'source='+_this.settings.source+'&search_category=registration_teams&template=registration_search_results&text=' + encodeURIComponent($(searchTerm).val()) + _this.filterTeamByClassification( searchTerm );

        $('.results-teams').remove();

        _this.executeSearch({
            postString: data,
            event: _this.settings.eventId,
            url: '/event/' + _this.settings.eventId + '/search/',
            listClass: 'results-teams content',
            header: ['Team title', 'Team owner'],
            entryName: 'team[id]',
            collectionAccessor: 'teams,captains',
            formatEntry: function(entity, row, name, callback) {
                var contact = entity.originatingAccount.contact;
                var entryLi = '<li class="search-result-item"><label for="team-'+entity.id+'" class="search-result-item-label"><input name="'+name+'" type="radio" value="'+entity.id+'" id="team-'+entity.id+'" class="checkbox-field" />' + entity.title + ' ' + contact.firstName+' '+contact.lastName+'</label></li>';
                callback(entryLi);
            }
        }, function(){
            return false;
        },
        _parent);
    },
    accounts: function(_parent,searchTerm) {
        var _this = this;

        $('.results-accounts').remove();

        _this.executeSearch({
            postString: 'source='+_this.settings.source+'&search_category=accounts&search_term=' + encodeURIComponent($(searchTerm).val()),
            event: _this.settings.eventId,
            url: '/event/' + _this.settings.eventId + '/search/',
            listClass: 'results-accounts content',
            header: ['ID', 'Name'],
            entryName: 'account[id]',
            collectionAccessor: 'accounts',
            formatEntry: function(entity, row, name, callback) {
                var contactName = entity.contact.firstName+' '+entity.contact.lastName;
                var entryLi = '<li class="search-result-item"><label for="account-'+entity.id+'" class="search-result-item-label"><input name="'+name+'" type="radio" value="'+entity.id+'" id="account-'+entity.id+'" class="checkbox-field" />' + contactName + '</label></li>';
                callback(entryLi);
                }
        }, function() {
            return false;
        },
        _parent);
    },
    participants: function(_parent,searchTerm) {
        var _this = this;

        $('.results-registrations').remove();

        _this.executeSearch({
            postString: 'source='+_this.settings.source+'&search_category=participants&search_term=' + encodeURIComponent($(searchTerm).val()),
            event: _this.settings.eventId,
            url: '/event/' + _this.settings.eventId + '/search/',
            listClass: 'results-registrations content',
            header: ['ID', 'Name'],
            entryName: 'registration[parentRegistration]',
            collectionAccessor: 'participants',
            formatEntry: function(entity, row, name, callback) {
                var contactName = entity.firstName+' '+entity.lastName;
                var entryTR = '<li class="search-result-item"><label for="registration-'+entity.id+'" class="search-result-item-label"><input name="'+name+'" type="radio" value="'+entity.id+'" id="registration-'+entity.id+'" class="checkbox-field" />' + contactName+'</label></li>';
                callback(entryTR);
            }
        }, function() {
            return false;
        },
        _parent);
    },
    executeSearch: function(settings, callback, _parent) {
        var _this = this;

        _parent = $(_parent);

        this._request = $.ajax({
            url: settings.url,
            type: "POST",
            data: settings.postString,
            dataType: "json",
            success: function(data) {
                // remove loading graphic
                _parent.removeClass('is-searching');

                if (data == null || !data.success) {
                    _parent.append('<div class="'+settings.listClass+' no-search-results">We\'re sorry, but the event you have selected has been closed.</div >');
                } else {
                    var entities = data.entities, hasResults = false;

                    var collections = settings.collectionAccessor.split(',');

                    for ( var i = 0; i < collections.length; i++ ){
                        for (var item in entities[collections[i]]) {
                            if (entities[collections[i]][item]) {
                                hasResults = true;
                                break;
                            }
                        }
                    }

                    if (hasResults) {
                        _parent.addClass('list-search-container')

                        if (data.html) {
                            _parent.empty();
                            _parent.append(data.html);
                        } else {
                            _parent.append('<ul class="ui-list search-results-list ' + settings.listClass + '"></ul>');

                            var row = 0;
                            var resultsList = $('.' + settings.listClass);

                            for (var entry in entities[settings.collectionAccessor]) {
                                settings.formatEntry(entities[settings.collectionAccessor][entry], row, settings.entryName, function(entry) {
                                    resultsList.append(entry);
                                    row++;
                                });
                            }
                        }

                        //new Table($('.'+settings.listClass+' .paginateTable').attr('id'));

                        if (!_parent.find('#cancelSearch')) _parent.append('<a style="margin-left: 140px;" id="cancelSearch" href="#" class="button green">Cancel</a>');

                        $('#cancelSearch').on('click', function() {
                            $('.parentWrapper .'+settings.listClass).slideUp('slow', function(){
                                $(this).remove();
                            });
                        });

                        $('.'+settings.listClass).show();

                    } else {
                        _parent.append('<div class="'+settings.listClass+' no-search-results">We\'re sorry, but your search yielded 0 results.</div >');
                    }
                }
            },
            error: function() {
                callback(null);
            }
        });
    },

    /**
    * @public
    * @method removeSelected
    * @memberof ConstituentSearch
    * @param {jQuery} $searchContainer The bound search container to remove a selected tag from
    * @param {boolean} bool Determines whether we should focus to the searchfield after removing
    *                       the selected tag. Helpful for programatically removing selected tags
    *                       without forcing the user to focus to the search field
    */
    removeSelected: function($searchContainer, bool) {
        var _this = this;
        var shouldFocus = bool ? bool : false;
        var $searchField = $searchContainer.find('.search-field');
        $searchContainer.removeClass('has-value has-selected-result');
        $searchField.prop('disabled', false).val('').trigger('blur');
        if (shouldFocus) {
            $searchField.focus();
        } else {
            _this.triggerSearch($searchField);
        }
    },

    removeSearchResult: function ($element) {
        var resultsContainer = $element.attr('data-search-results');

        $(resultsContainer).addClass('hide-content');
        $(resultsContainer).empty().removeClass('is-searching');
        $(resultsContainer).siblings('.search-filter').addClass('no-search-results');
    }
};